import React, { useState } from "react";
import { Link, navigate } from "gatsby";
import SearchBar from "../elements/search";
import { checkIsLoggedIn } from "../../utils/checkAuth";

interface MenuItem {
  label: string;
  path?: string; // `path` might be undefined, so we need a fallback
}

const Menu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleAuthButtonClick = () => {
    if (checkIsLoggedIn()) {
      // Log out and refresh the page
      navigate("/dashboard/");
    } else {
      // Log in and refresh the page
      navigate("/login/");
    }
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  const menuItems = [
    { label: "About", to: "/about/" },
    {
      label: "Places",
      to: "/",
      submenu: [
        { label: "Countries", to: "/category/" },
        { label: "Orientation", to: "/highlights/" },
        { label: "Scotland", to: "/highlights/scotland/" },
        { label: "Activities", to: "/tag/" },
        { label: "Features", to: "/features/" },
        { label: "Types", to: "/types/" },
      ],
    },
    { label: "Events", to: "/events/" },
    { label: "Stories", to: "/stories/" },
    { label: "Archive", to: "/archive/" },
    // { label: "Collections", to: "/collections/" }, 
  ];

  return (
    <nav className="menu-list">
      {/* Hamburger Menu */}
      <button
        className="hamburger"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        {isMenuOpen ? "✕" : "☰"}
      </button>

      {/* Search Bar */}
      <SearchBar />

      {/* Menu Items */}
      <ul className={`menu-items ${isMenuOpen ? "open" : ""}`}>
        {menuItems.map((item, index) => (
          <li key={index} className="menu-item">
            <Link to={item.to} onClick={handleLinkClick}>{item.label}</Link>
            {item.submenu && (
              <ul className="submenu">
                {item.submenu.map((subItem, subIndex) => (
                  <li key={subIndex}>
                    <Link to={subItem.to}>{subItem.label}</Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
        {/* Login/Dashboard Button */}
        <li className="menu-item auth-item">
          <button
            onClick={handleAuthButtonClick}
            className="login button orange"
            aria-label={checkIsLoggedIn() ? "Go to Dashboard" : "Login"}
          >
            {checkIsLoggedIn() ? "Dashboard" : "Login"}
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Menu;
